/**
 * Base-URL resolver for auth HTTP clients.
 *
 * Returns a thunk that resolves to the API host at call time, with a
 * localhost override so local development proxies through the Next.js
 * dev server instead of hitting a remote host directly.
 *
 * @module
 */

/**
 * Creates a lazy base-URL getter.
 *
 * @param resolvedClientAppHost - Primary host (e.g. `https://www.zoocasa.com`).
 * @param resolvedAuthApiHost   - Optional override for the auth-specific API
 *                                host. Falls back to {@link resolvedClientAppHost}
 *                                when omitted.
 * @returns A zero-arg function that returns the base URL string.  On
 *          `localhost` the function returns `''` so requests go through
 *          the local dev-server proxy.
 */
export function createGetBaseUrl(resolvedClientAppHost: string | undefined, resolvedAuthApiHost?: string): () => string {
  const host = resolvedAuthApiHost ?? resolvedClientAppHost ?? '';
  return () => {
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      return '';
    }
    return host;
  };
}
